import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

const Navbar = () => {
    const { t } = useTranslation();

    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [hasFadeIn, setHasFadeIn] = useState(false);
    const [hasFadeOut, setHasFadeOut] = useState(false);

    const currentLanguage = i18n.language.slice(0, 2);

    const handleLanguageChange = (e: React.MouseEvent) => {
        const language = e.currentTarget.getAttribute("id");
        if (language) {
            i18n.changeLanguage(language);
        }
    };

    const toggleMenu = () => {
        if (menuIsOpen) {
            setMenuIsOpen(false);
            setHasFadeIn(false);
            setHasFadeOut(true);
        } else {
            setMenuIsOpen(true);
            setHasFadeIn(true);
            setHasFadeOut(false);
        }
    };

    return (
        <header className="nav">
            <nav className=" container flex flex-jc-sb flex-ai-c">
                <a href="/">
                    <img
                        className="nav__logo"
                        src="assets/logos/ticket-restaurant-logo.svg"
                        alt="Ticket Restaurant"
                    />
                </a>

                <div className={`nav__collapse ${menuIsOpen ? "open" : ""}`}>
                    <div className="nav__toggle" onClick={toggleMenu}>
                        <span />
                        <span />
                        <span />
                    </div>

                    <div className="nav__background">&nbsp;</div>

                    <div
                        className={`nav__links-container ${
                            hasFadeIn ? "fade-in" : ""
                        } ${hasFadeOut ? "fade-out" : ""}`}
                    >
                        <div className="nav__links">
                            <Scrollspy
                                items={["buy-voucher", "how-it-works"]}
                                currentClassName="active"
                            >
                                <a
                                    className="nav__section"
                                    href="/#buy-voucher"
                                    onClick={toggleMenu}
                                >
                                    Vouchers
                                </a>
                                <a
                                    className="nav__section"
                                    href="/#how-it-works"
                                    onClick={toggleMenu}
                                >
                                    {t("navbar.howItWorks")}
                                </a>
                                <button
                                    type="button"
                                    id="pt"
                                    className={`nav__language ${
                                        currentLanguage === "pt" ? "active" : ""
                                    }`}
                                    onClick={handleLanguageChange}
                                >
                                    PT
                                </button>
                                <button
                                    type="button"
                                    id="en"
                                    className={`nav__language ${
                                        currentLanguage === "en" ? "active" : ""
                                    }`}
                                    onClick={handleLanguageChange}
                                >
                                    EN
                                </button>
                            </Scrollspy>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
